/**
 * useDocumentTitle.js — Route-specific document title updates
 * 
 * Part of GRANULLO_POSTLAUNCH_FIXPACK_V2.
 * Updates document.title for share previews and browser tabs.
 * Metadata-only, no UX changes.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route-specific titles (copy only)
const ROUTE_TITLES = {
  '/': 'Granullo',
  '/start': 'Granullo',
  '/start-here': 'Granullo',
  '/intent-records': 'Granullo',
  '/preparedness': 'Granullo',
  '/pricing': 'Granullo',
  '/cbdc': 'Granullo',
  '/founder': 'Granullo',
  '/login': 'Granullo',
  '/glossary': 'Granullo',
  '/how-granullo-works': 'Granullo',
};

// Default title
const DEFAULT_TITLE = 'Granullo';

/**
 * Hook to update document title based on current route
 */
export const useDocumentTitle = (customTitle = null) => {
  const location = useLocation();
  
  useEffect(() => {
    // Use custom title if provided, otherwise use route-based title
    const title = customTitle || ROUTE_TITLES[location.pathname] || DEFAULT_TITLE;
    document.title = title;
  }, [location.pathname, customTitle]);
};

/**
 * Set document title directly (for components that don't use the hook)
 */
export const setDocumentTitle = (title) => {
  document.title = title || DEFAULT_TITLE;
};

export default useDocumentTitle;
